var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-edit" },
    [
      _c(
        "actionBarComponent",
        {
          attrs: {
            slots: 1,
            showSave: !_vm.somenteConsulta,
            title: _vm.$t("__.Crud.tiposVenda.edit_vue_html.tipoVendaEdit"),
          },
          on: { onSave: _vm.save },
          scopedSlots: _vm._u([
            {
              key: "buttonSlot0",
              fn: function (ref) {
                var open = ref.open
                return _vm.modelId
                  ? _c(
                      "div",
                      {
                        attrs: { title: _vm.$t("__.ts.historicoAlteracoes") },
                        on: {
                          click: function ($event) {
                            open(
                              0,
                              _vm.$t("__.ts.historicoAlteracoes"),
                              "lg-modal"
                            )
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-history",
                          attrs: { slot: "button", "aria-hidden": "true" },
                          slot: "button",
                        }),
                      ]
                    )
                  : _vm._e()
              },
            },
          ]),
        },
        [
          _c(
            "div",
            { attrs: { slot: "modalSlot0" }, slot: "modalSlot0" },
            [
              _c("logEntidadeComponent", {
                attrs: {
                  withoutFranquiaId: true,
                  registroId: _vm.modelId,
                  entidade: _vm.tipoLogEntidade,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { novalidate: "novalidate" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.save($event)
            },
          },
        },
        [
          _c("fieldset", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("descricao"),
                        expression: "errors.first('descricao')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: {
                          for: "descricao",
                          title: _vm.$t("__.obrigatorio"),
                        },
                      },
                      [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.tiposVenda.edit_vue_html.descricao"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        { name: "focus", rawName: "v-focus" },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.descricao,
                          expression: "model.descricao",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|max:256",
                          expression: "'required|max:256'",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        autocomplete: "off",
                        type: "text",
                        id: "descricao",
                        name: "descricao",
                        disabled: _vm.somenteConsulta,
                      },
                      domProps: { value: _vm.model.descricao },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.model, "descricao", $event.target.value)
                        },
                      },
                    }),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-2" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("utilizaValorCusto"),
                        expression: "errors.first('utilizaValorCusto')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "utilizaValorCusto" },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.tiposVenda.edit_vue_html.utilizaValorCusto"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("checkbox-component", {
                      attrs: {
                        id: "utilizaValorCusto",
                        name: "utilizaValorCusto",
                        disabled: _vm.somenteConsulta,
                      },
                      model: {
                        value: _vm.model.utilizaValorCusto,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "utilizaValorCusto", $$v)
                        },
                        expression: "model.utilizaValorCusto",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-1" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("emiteNFe"),
                        expression: "errors.first('emiteNFe')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "emiteNFe" },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.tiposVenda.edit_vue_html.emiteNFe"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("checkbox-component", {
                      attrs: {
                        id: "emiteNFe",
                        name: "emiteNFe",
                        disabled: _vm.somenteConsulta,
                      },
                      model: {
                        value: _vm.model.emiteNFe,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "emiteNFe", $$v)
                        },
                        expression: "model.emiteNFe",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-1" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("emiteNFSe"),
                        expression: "errors.first('emiteNFSe')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "emiteNFSe" },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.tiposVenda.edit_vue_html.emiteNFSe"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("checkbox-component", {
                      attrs: {
                        id: "emiteNFSe",
                        name: "emiteNFSe",
                        disabled: _vm.somenteConsulta,
                      },
                      model: {
                        value: _vm.model.emiteNFSe,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "emiteNFSe", $$v)
                        },
                        expression: "model.emiteNFSe",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("pontuaProgramaFidelidade"),
                        expression: "errors.first('pontuaProgramaFidelidade')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "pontuaProgramaFidelidade" },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.tiposVenda.edit_vue_html.pontuaProgramaFidelidade"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("checkbox-component", {
                      attrs: {
                        id: "pontuaProgramaFidelidade",
                        name: "pontuaProgramaFidelidade",
                        disabled: _vm.somenteConsulta,
                      },
                      model: {
                        value: _vm.model.pontuaProgramaFidelidade,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "pontuaProgramaFidelidade", $$v)
                        },
                        expression: "model.pontuaProgramaFidelidade",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("permiteControlados"),
                        expression: "errors.first('permiteControlados')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "permiteControlados" },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.tiposVenda.edit_vue_html.permiteControlados"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("checkbox-component", {
                      attrs: {
                        id: "permiteControlados",
                        name: "permiteControlados",
                        disabled: _vm.somenteConsulta,
                      },
                      model: {
                        value: _vm.model.permiteControlados,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "permiteControlados", $$v)
                        },
                        expression: "model.permiteControlados",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.franquiaGrupoAtlas
                ? _c("div", { staticClass: "col-sm-2" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first("movimentaEstoque"),
                            expression: "errors.first('movimentaEstoque')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: { for: "movimentaEstoque" },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.tiposVenda.edit_vue_html.movimentaEstoque"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("data-tooltip-component", {
                          attrs: {
                            text: _vm.$t(
                              "__.Crud.tiposVenda.edit_vue_html.movimentaEstoqueTooltip"
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("checkbox-component", {
                          attrs: {
                            id: "movimentaEstoque",
                            name: "movimentaEstoque",
                            disabled: _vm.somenteConsulta,
                          },
                          model: {
                            value: _vm.model.movimentaEstoque,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "movimentaEstoque", $$v)
                            },
                            expression: "model.movimentaEstoque",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            !_vm.franquiaFracionadora
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first(
                              "naturezaOperacaoDentroEstadoId"
                            ),
                            expression:
                              "errors.first('naturezaOperacaoDentroEstadoId')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: {
                              for: "naturezaOperacaoDentroEstadoId",
                              title: _vm.$t(
                                "__.Crud.tiposVenda.edit_vue_html.cfopDentroEstadoTooltip"
                              ),
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.tiposVenda.edit_vue_html.cfopDentroEstado"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("data-tooltip-component", {
                          attrs: {
                            text: _vm.$t(
                              "__.Crud.tiposVenda.edit_vue_html.cfopDentroEstadoTooltip"
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "naturezaOperacaoDentroEstadoId",
                            name: "naturezaOperacaoDentroEstadoId",
                            data: _vm.naturezaOperacaoOptions,
                            searchable: true,
                            disabled: _vm.somenteConsulta,
                          },
                          model: {
                            value: _vm.model.naturezaOperacaoDentroEstadoId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "naturezaOperacaoDentroEstadoId",
                                $$v
                              )
                            },
                            expression: "model.naturezaOperacaoDentroEstadoId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first(
                              "naturezaOperacaoForaEstadoId"
                            ),
                            expression:
                              "errors.first('naturezaOperacaoForaEstadoId')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: {
                              for: "naturezaOperacaoForaEstadoId",
                              title: _vm.$t(
                                "__.Crud.tiposVenda.edit_vue_html.cfopForaEstadoTooltip"
                              ),
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.tiposVenda.edit_vue_html.cfopForaEstado"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("data-tooltip-component", {
                          attrs: {
                            text: _vm.$t(
                              "__.Crud.tiposVenda.edit_vue_html.cfopForaEstadoTooltip"
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "naturezaOperacaoForaEstadoId",
                            name: "naturezaOperacaoForaEstadoId",
                            data: _vm.naturezaOperacaoOptions,
                            searchable: true,
                            disabled: _vm.somenteConsulta,
                          },
                          model: {
                            value: _vm.model.naturezaOperacaoForaEstadoId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "naturezaOperacaoForaEstadoId",
                                $$v
                              )
                            },
                            expression: "model.naturezaOperacaoForaEstadoId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.franquiaFracionadora
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first(
                              "naturezaOperacaoDentroEstadoFracionamentoId"
                            ),
                            expression:
                              "errors.first('naturezaOperacaoDentroEstadoFracionamentoId')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: {
                              for: "naturezaOperacaoDentroEstadoFracionamentoId",
                              title: _vm.$t(
                                "__.Crud.tiposVenda.edit_vue_html.cfopDentroEstadoTooltip"
                              ),
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.tiposVenda.edit_vue_html.cfopDentroEstado"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("data-tooltip-component", {
                          attrs: {
                            text: _vm.$t(
                              "__.Crud.tiposVenda.edit_vue_html.cfopDentroEstadoTooltip"
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "naturezaOperacaoDentroEstadoFracionamentoId",
                            name: "naturezaOperacaoDentroEstadoFracionamentoId",
                            data: _vm.naturezaOperacaoOptions,
                            searchable: true,
                            disabled: _vm.somenteConsulta,
                          },
                          model: {
                            value:
                              _vm.model
                                .naturezaOperacaoDentroEstadoFracionamentoId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "naturezaOperacaoDentroEstadoFracionamentoId",
                                $$v
                              )
                            },
                            expression:
                              "model.naturezaOperacaoDentroEstadoFracionamentoId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first(
                              "naturezaOperacaoForaEstadoFracionamentoId"
                            ),
                            expression:
                              "errors.first('naturezaOperacaoForaEstadoFracionamentoId')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: {
                              for: "naturezaOperacaoForaEstadoFracionamentoId",
                              title: _vm.$t(
                                "__.Crud.tiposVenda.edit_vue_html.cfopForaEstadoTooltip"
                              ),
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.tiposVenda.edit_vue_html.cfopForaEstado"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("data-tooltip-component", {
                          attrs: {
                            text: _vm.$t(
                              "__.Crud.tiposVenda.edit_vue_html.cfopForaEstadoTooltip"
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "naturezaOperacaoForaEstadoFracionamentoId",
                            name: "naturezaOperacaoForaEstadoFracionamentoId",
                            data: _vm.naturezaOperacaoOptions,
                            searchable: true,
                            disabled: _vm.somenteConsulta,
                          },
                          model: {
                            value:
                              _vm.model
                                .naturezaOperacaoForaEstadoFracionamentoId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "naturezaOperacaoForaEstadoFracionamentoId",
                                $$v
                              )
                            },
                            expression:
                              "model.naturezaOperacaoForaEstadoFracionamentoId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm.franquiaGrupoAtlas
                ? _c("div", { staticClass: "col-sm-2" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first("tipoVendaGrupoAtlas"),
                            expression: "errors.first('tipoVendaGrupoAtlas')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(
                                  "__.Crud.tiposVenda.edit_vue_html.tipoVendaGrupoAtlas"
                                )
                              ) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("checkbox-component", {
                          attrs: {
                            disabled: _vm.somenteConsulta && _vm.isAdmin,
                          },
                          on: {
                            change: function ($event) {
                              !_vm.model.tipoVendaGrupoAtlas
                                ? (_vm.model.permiteNFeSemFaturamento = false)
                                : null
                            },
                          },
                          model: {
                            value: _vm.model.tipoVendaGrupoAtlas,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "tipoVendaGrupoAtlas", $$v)
                            },
                            expression: "model.tipoVendaGrupoAtlas",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.franquiaGrupoAtlas
                ? _c("div", { staticClass: "col-sm-3" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first("permiteNFeSemFaturamento"),
                            expression:
                              "errors.first('permiteNFeSemFaturamento')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(
                                  "__.Crud.tiposVenda.edit_vue_html.permiteNFeSemFaturamento"
                                )
                              ) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("data-tooltip-component", {
                          attrs: {
                            text: _vm.$t(
                              "__.Crud.tiposVenda.edit_vue_html.permiteNFeSemFaturamentoTooltip"
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("checkbox-component", {
                          attrs: {
                            disabled: _vm.somenteConsulta && _vm.isAdmin,
                          },
                          model: {
                            value: _vm.model.permiteNFeSemFaturamento,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "permiteNFeSemFaturamento",
                                $$v
                              )
                            },
                            expression: "model.permiteNFeSemFaturamento",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.franquiaGrupoAtlas
                ? _c("div", { staticClass: "col-sm-3" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first(
                              "permiteNFSeSemFaturamento"
                            ),
                            expression:
                              "errors.first('permiteNFSeSemFaturamento')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(
                                  "__.Crud.tiposVenda.edit_vue_html.permiteNFSeSemFaturamento"
                                )
                              ) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("data-tooltip-component", {
                          attrs: {
                            text: _vm.$t(
                              "__.Crud.tiposVenda.edit_vue_html.permiteNFSeSemFaturamentoTooltip"
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("checkbox-component", {
                          attrs: {
                            disabled: _vm.somenteConsulta && _vm.isAdmin,
                          },
                          model: {
                            value: _vm.model.permiteNFSeSemFaturamento,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "permiteNFSeSemFaturamento",
                                $$v
                              )
                            },
                            expression: "model.permiteNFSeSemFaturamento",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.franquiaGrupoAtlas
                ? _c("div", { staticClass: "col-sm-3" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first(
                              "permiteNFCeSemFaturamento"
                            ),
                            expression:
                              "errors.first('permiteNFCeSemFaturamento')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(
                                  "__.Crud.tiposVenda.edit_vue_html.permiteNFCeSemFaturamento"
                                )
                              ) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("data-tooltip-component", {
                          attrs: {
                            text: _vm.$t(
                              "__.Crud.tiposVenda.edit_vue_html.permiteNFCeSemFaturamentoTooltip"
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("checkbox-component", {
                          attrs: {
                            disabled: _vm.somenteConsulta && _vm.isAdmin,
                          },
                          model: {
                            value: _vm.model.permiteNFCeSemFaturamento,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "permiteNFCeSemFaturamento",
                                $$v
                              )
                            },
                            expression: "model.permiteNFCeSemFaturamento",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm.franquiaGrupoAtlas
            ? _c(
                "fieldset-component",
                {
                  attrs: {
                    collapsed: false,
                    title: _vm.$t(
                      "__.Crud.tiposVenda.edit_vue_html.tipoClientePermitidoFieldset"
                    ),
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "rows" }, slot: "rows" },
                    [
                      !_vm.somenteConsulta
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-sm-10" }, [
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "tipoClientePermitidoId" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t(
                                              "__.Crud.tiposVenda.edit_vue_html.tipoCliente"
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("combo-component", {
                                    attrs: {
                                      id: "tipoClientePermitidoId",
                                      name: "tipoClientePermitidoId",
                                      data: _vm.tiposClientesPermitidosOptions,
                                      disabled: _vm.somenteConsulta,
                                    },
                                    model: {
                                      value: _vm.tipoClientePermitidoId,
                                      callback: function ($$v) {
                                        _vm.tipoClientePermitidoId = $$v
                                      },
                                      expression: "tipoClientePermitidoId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.somenteConsulta
                        ? _c("buttonIncluirComponent", {
                            on: { click: _vm.onInclusaoTipoClientePermitido },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("grid-component", {
                        attrs: {
                          data: _vm.model.tiposClientesPermitidos,
                          columns: _vm.gridColumnsTiposClientesPermitidos,
                          "show-table-head": false,
                          "show-table-foot": false,
                          "show-edit-item": false,
                          showActionColumn: !_vm.somenteConsulta,
                        },
                        on: { "remove-item": _vm.onRemoveTipoClientePermitido },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("fieldset", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12 newbtn" }, [
                _c("div", { staticClass: "form-group" }, [
                  !_vm.somenteConsulta
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          attrs: { type: "submit" },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-save",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("__.Crud.salvar")) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.cancel()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("__.Crud.voltar")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }